import { render, staticRenderFns } from "./PrevMatch.vue?vue&type=template&id=3dc88002&scoped=true&"
import script from "./PrevMatch.vue?vue&type=script&lang=js&"
export * from "./PrevMatch.vue?vue&type=script&lang=js&"
import style0 from "./PrevMatch.vue?vue&type=style&index=0&id=3dc88002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc88002",
  null
  
)

export default component.exports